export default __webpack_public_path__ + "static/media/mask_group_12_13932.f04c31bf.png";